import { createRouter, createWebHistory, type RouteRecordRaw } from 'vue-router';
import Home from '@/views/Home.vue';
import { Auth } from 'aws-amplify';

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'home',
    component: Home
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/Login.vue')
  }
];

const router = createRouter({
  history: createWebHistory(),
  routes
});

router.beforeEach(async (to) => {
  if (to.name === 'login') {
    try {
      await Auth.currentSession();
      return { name: 'home' };
    } catch {
      return true;
    }
  }

  try {
    await Auth.currentSession();
    return true;
  } catch {
    return { name: 'login' };
  }
});

export default router;
